<template>
  <status-chip
    :status="status"
    :statuses="types"
  ></status-chip>
</template>

<script>
import { ref } from '@vue/composition-api'
import StatusChip from '@/components/chips/StatusChip.vue'
import usePaymentsTypesList from '@/components/lists/paymentsTypes'

export default {
  components: {
    StatusChip,
  },
  props: {
    status: {
      type: Number,
      required: true,
    },
  },
  setup() {
    const { paymentsTypesList } = usePaymentsTypesList()
    const types = ref(paymentsTypesList)

    return {
      types,
    }
  },
}
</script>
